$bog_favicon $mol_plugin
	Icon $mol_view
